module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921085649_T.57d9f263.jpg";